// extracted by mini-css-extract-plugin
export default {"containerLoading":"Loading_containerLoading__jeXR1","textLoading":"Loading_textLoading__NEd5h"};